import { FunctionComponent, useState } from "react";
import { useTranslation } from "react-i18next";

import { faLinkedinIn } from "@fortawesome/free-brands-svg-icons";
import { faUpload } from "@fortawesome/pro-regular-svg-icons";

import { Icon } from "@/components";
import { Button } from "@/components/Button/Button";
import { ButtonColor, ButtonSize } from "@/components/Button/types";

import { UploadConnectionsModal } from "./modals/UploadConnectionsModal";
import { SettingsCard } from "./SettingsCard";

/**
 * Non-sending users cannot connect LinkedIn or email for outreach (that is managed by an
 * admin in Company Settings), so every account control on this tab is disabled for them —
 * the only action they keep is uploading their LinkedIn connections export via CSV.
 */
export const NonSendingConnectionsCard: FunctionComponent = () => {
	const { t } = useTranslation();
	const ts = (key: string) => t(`account.connectedAccounts.${key}`);

	const [showUploadModal, setShowUploadModal] = useState(false);

	return (
		<SettingsCard
			icon={faLinkedinIn}
			subtitle={ts("nonSendingSubtitle")}
			title={ts("linkedinTitle")}
		>
			<div className="flex flex-col gap-4 px-5 py-4">
				<p className="text-[12.5px] leading-relaxed text-text-meta">{ts("nonSendingUploadHint")}</p>

				<div>
					<Button
						color={ButtonColor.ACTION_SECONDARY}
						image={<Icon className="mr-2 h-4 w-4" icon={faUpload} />}
						size={ButtonSize.M}
						title={ts("uploadConnections")}
						type="button"
						onClick={() => setShowUploadModal(true)}
					/>
				</div>
			</div>

			<UploadConnectionsModal
				handleClose={() => setShowUploadModal(false)}
				isVisible={showUploadModal}
			/>
		</SettingsCard>
	);
};
